import { combineReducers } from 'redux';
import { SortAndFilterReducer } from 'Redux/reducers/sortAndFilterReducer';

export default combineReducers({ SortAndFilterReducer });
